import { MemberStatusEnum } from '../Enum/MemberStatusEnum';
import Authorization from './Authorization';
export const chpAzureWebUrl = 'https://chp-react-dev.azurewebsites.net/';

export const apiString = new Authorization().APIUrl;

export const GOOGLE_MAPS_API_KEY = 'AIzaSyC8HV3l5DT0KYh0rivIA-qV4f9EX8ULsqc' as const;
// The user id is actually the provider id. This should likely be refactored soon.
export const ProviderId = new Authorization().UserId;

export const activeStatuses = [
    MemberStatusEnum.Active,
    MemberStatusEnum.Scheduled,
    MemberStatusEnum.Undetermined,
    MemberStatusEnum.UncompensatedCare,
    MemberStatusEnum.HRAInReview,
    MemberStatusEnum.Suspended,
    MemberStatusEnum.FUHFUMInProgress,
    MemberStatusEnum.LostInsuranceCoverage,
    MemberStatusEnum.PreparingForGraduation,
    MemberStatusEnum.AndNextInProgress,
    MemberStatusEnum.Incarcerated,
];

export const WidgetsEnum = {
    ADULT_HEALTH_SUMMARY: 'Adult Health Summary',
    AGED_SERVICES: 'Aged Services',
    MEMBER_PROMISES_BY_TEAM: 'Member Promises By Team',
    APPOINTMENTS_NOT_DOCUMENTED: 'Appointments Not Documented',
    BMI_SUMMARY: 'BMI Summary',
    BP_SUMMARY: 'BP Summary',
    BREAST_CANCER_SCREENING_SUMMARY: 'Breast Cancer Screening Summary',
    MEMBERS_MISSING_CARE_PLAN_SIGNATURE: 'Members Missing Care Plan Signature',
    DEPRESSION_FOLLOW_UP_SUMMARY: 'Depression Follow-Up Summary',
    DEPRESSION_SCREENING_SUMMARY: 'Depression Screening Summary',
    DIABETIC_EYE_EXAM: 'Diabetic Eye Exam Summary',
    DOCUMENTATION_TRACKING_SUMMARY: 'Documentation Tracking Summary',
    HGB_A1C_SUMMARY: 'Hgb A1C Summary',
    HGB_A1C_FOR_BHDX_SUMMARY: 'Hgb A1C For BHDX Summary',
    LIPID_FOR_BHDX_SUMMARY: 'Lipid For BHDX Summary',
    MEDICATION_RECONCILIATION_SUMMARY: 'Medication Reconciliation Summary',
    COLORECTAL_CANCER_SCREENING_SUMMARY: 'Colorectal Cancer Screening Summary',
    CERVICAL_CANCER_SCREENING_SUMMARY: 'Cervical Cancer Screening Summary',
    MEMBERS_MISSING_GENDER: 'Members Missing Gender',
    MEMBERS_NOT_SCHEDULED_WITH_BH_OR_NP: 'Members Not Scheduled With BH or NP',
    TEAM_IN_PERSON_VISITS_RATE: 'Team In Person Visit Rate',
    INDIVIDUAL_PROVIDER_VISIT_PERFORMANCE: 'Individual Provider Visit Performance',
    MISSING_OR_EXPIRED_CONSENTS: 'Missing or Expired Consents',
    MEMBERS_WITH_NO_PRIMARY_DIAGNOSIS: 'Members With No Primary Diagnosis',
    MEMBERS_WITHOUT_ENCOUNTER: 'Members Without Encounter',
    ONBOARDING_PERFORMANCE: 'Onboarding Performance',
    PATIENT_PANEL_ERRORS: 'Patient Panel Errors',
    MEDICAL_DOCUMENTS_TO_REVIEW: 'Medical Documents to Review',
    SCHEDULER_PERFORMANCE_HUB: 'Scheduler Performance Hub',
    REVENUE_METRICS: 'Revenue Metrics',
    TEAM_APPOINTMENT_HUB: 'Team Appointment Hub',
    SOCIAL_WORKER_REQUEST_SUMMARY: 'Social Worker Request Summary',
    SUBMITTED_CLAIM_SUMMARY: 'Submitted Claim Summary',
    TRANSITIONAL_CARE_SUMMARY: 'Transitional Care Summary',
    TEAM_MEMBER_SUMMARY: 'Team Member Summary',
    TRANSITIONAL_CARE: 'Transitional Care',
    TRANSITIONAL_CARE_PERFORMANCE: 'Transitional Care Performance',
    FUHFUM_EXCEPTION_SUMMARY: 'FUHFUM Exception Summary',
    FUHFUM_INPROGRESS_SUMMARY: 'FUHFUM InProgress Summary',
    FUHFUM_UNDETERMINED_SUMMARY: 'FUHFUM Undetermined Summary',
    FUHFUM_QUALITY_METRICS: 'FUHFUM Quality Metrics',
    SURVEY_SUMMARY: 'Survey Summary',
    FUHFUM_HRA_FULL_PROGRAM_REFERRAL_TAG_SUMMARY: 'FUHFUM / HRA Full Program Referral Tag Summary',
    WIDGET_USAGE: 'Widget Usage',
    FUHFUM_VISIT_READMISSION_SUMMARY: 'FUHFUM Visit / Readmission Summary',
    FUHFUM_HRA_FULL_PROGRAM_REFERRALS: 'FUHFUM / HRA Full Program Referrals',
    BH_DIAGNOSTIC_SUMMARY: 'BH Diagnostic Summary',
    TELEMONITORING_OUT_OF_LIMITS_BY_USER: 'Telemonitoring Out Of Limits By User',
    ER_ADMISSIONS: 'ER Admissions',
    EDUCATION_SESSION_REMINDER: 'Education Session Reminder',
    CLEAN_CLAIM_SUMMARY: 'Clean Claim Summary',
    EMERGENCY_DEPARTMENT_VISITS: 'Emergency Department Visits',
    MEMBER_COST_COMPARISON: 'Member Cost Comparison',
    TOTAL_AND_HIGH_COST_OVERVIEW: 'Total / High Cost Members Overview',
    ANDNEXT_CENSUS_SUMMARY: 'andNext Census Summary',
    ONBOARDING_PERFORMANCE_DASHBOARD: 'Onboarding Performance Dashboard',
    SNC_DASHBOARD: 'SNC Dashboard',
};

export interface IEnumMetadata {
    value: number;
    text: string;
}

export interface IAppointmentTypeEnumMetadata extends IEnumMetadata {
    abbrev?: string;
    preferredType?: number;
    durationTimes: { default: number; [key: string]: number };
}

export interface IAppointmentStatusEnumMetadata extends IEnumMetadata {
    eventColor: string;
    rescheduledEventColor?: string;
    iconClass: string;
}

export const appointmentTypeEnums: IAppointmentTypeEnumMetadata[] = [
    { value: 31, text: 'ART Staffing', abbrev: 'ART', durationTimes: { default: 60 } },
    { value: 20, text: 'Behavioral Health Appointment', abbrev: 'BHA', durationTimes: { default: 90 } },
    { value: 7, text: 'Care Planning', abbrev: 'CP', durationTimes: { default: 30 } },
    { value: 16, text: 'Check In Call', abbrev: 'P', preferredType: 3, durationTimes: { default: 30 } },
    { value: 3, text: 'Follow Up', abbrev: 'F', durationTimes: { default: 90 } },
    { value: 27, text: 'HRA', abbrev: 'HRA', durationTimes: { default: 120 } },
    { value: 28, text: 'HRA Follow up', abbrev: 'HRAF', durationTimes: { default: 30 } },
    { value: 2, text: 'Initial', abbrev: 'I', durationTimes: { default: 90 } },
    { value: 1, text: 'Onboarding', abbrev: 'O', durationTimes: { default: 120 } },
    { value: 8, text: 'PCP Appointment', abbrev: 'PCP', preferredType: 19, durationTimes: { default: 30 } },
    { value: 4, text: 'Phone Call', abbrev: 'P', preferredType: 3, durationTimes: { default: 30 } },
    { value: 24, text: 'Provider Leave', abbrev: 'PL', durationTimes: { default: 30 } },
    { value: 25, text: 'Rescheduled', abbrev: 'R', durationTimes: { default: 30 } },
    { value: 6, text: 'Social Services', abbrev: 'S', durationTimes: { default: 30 } },
    { value: 26, text: 'Team Meeting', abbrev: 'TM', durationTimes: { default: 30 } },
    { value: 17, text: 'Telemedicine', abbrev: 'T', preferredType: 3, durationTimes: { default: 30 } },
    { value: 22, text: 'Transitional Care', abbrev: 'TC', durationTimes: { default: 30 } },
    { value: 29, text: 'Transportation', abbrev: 'TP', durationTimes: { default: 30 } },
    { value: 23, text: 'Urgent Response', abbrev: 'UR', durationTimes: { default: 30 } },
    { value: 30, text: 'FUHFUM', abbrev: 'FUHFUM', durationTimes: { default: 90, 'Nurse Practitioner': 120, 'Behavioural Health Specialist': 120 } },
    { value: 21, text: 'Outside Health Appointment', abbrev: 'OHA', durationTimes: { default: 30 } },
    { value: 32, text: 'Integrated', abbrev: 'INT', durationTimes: { default: 90 } },
    { value: 33, text: 'DB Onboard', abbrev: 'DBO', durationTimes: { default: 90 } },
];

export const localStorageKeys = {
    SELECTED_MEMBER_STATUS: 'selectedMemberStatus',
    SELECTED_TAB: 'selectedTab',
    SELECTED_MEMBER_DETAIL_PAGE: 'selectedMemberDetailPage',
};

export const meansOfEngagementEnums = [
    { value: 1, text: 'In-Person/Home', iconCls: 'b-fa b-fa-user' },
    { value: 2, text: 'Phone', iconCls: 'b-fa b-fa-phone' },
    { value: 3, text: 'Telemedicine', iconCls: 'b-fa b-fa-desktop' },
];

export const surveyStatusEnumbers = [
    { value: 1, text: 'Incomplete' },
    { value: 2, text: 'Complete' },
    { value: 3, text: 'Closed' },
];

export const SELECTED_PROVIDER_ID = 'SELECTED_PROVIDER_ID';
export const USE_HOME_ADDRESS = 'USE_HOME_ADDRESS';
export const MAP_DISTANCE_APPT_STATUS = 'MAP_DISTANCE_APPT_STATUS';

export const rescheduledEventColor = '#b495c7';

export const appointmentStatusEnums: IAppointmentStatusEnumMetadata[] = [
    {
        value: 3,
        text: 'Cancelled',
        iconClass: 'fa fa-ban',
        eventColor: '#DC3545',
        rescheduledEventColor,
    },
    {
        value: 4,
        text: 'Completed',
        iconClass: 'fa fa-check-circle',
        eventColor: '#28A745',
    },
    {
        value: 1,
        text: 'Confirmed',
        iconClass: 'fa fa-thumbs-up',
        eventColor: '#17A2B8',
    },
    {
        value: 2,
        text: 'No Call No Show',
        iconClass: 'fa fa-exclamation-circle',
        eventColor: '#6C757D',
        rescheduledEventColor,
    },
    {
        value: 5,
        text: 'Provider Unavailable',
        iconClass: 'fa fa-ban',
        eventColor: '#6C757E',
    },
    {
        value: 0,
        text: 'Unconfirmed',
        iconClass: 'fa fa-question',
        eventColor: '#EB984E',
    },
];

export const providerTypes = [
    { value: 1, text: 'Internal' },
    { value: 2, text: 'External' },
];

export const vitalTypes = [
    { type: 1, name: 'Systolic BP' },
    { type: 2, name: 'Diastolic BP' },
    { type: 3, name: 'Heart Rate' },
    { type: 4, name: 'Oximeter' },
    { type: 5, name: 'Scale' },
    { type: 6, name: 'Glucose' },
];

export const currentTimeNearest15Minutes = () => {
    const date = new Date();
    let minutes = date.getMinutes();
    let hours = date.getHours();
    const m = ((((minutes + 7.5) / 15) | 0) * 15) % 60;
    const h = (((minutes / 105 + 0.5) | 0) + hours) % 24;
    return new Date((hours = h), (minutes = m));
};

// Prepare sdoh question
export const languageList = [{ Answer: 'English' }, { Answer: 'Language other than English (please write)' }];
export const communicationBarriersList = [{ Answer: 'No' }, { Answer: 'ASL' }, { Answer: 'Foreign Language' }];
export const housingSituationList = [
    { Answer: 'I have housing' },
    {
        Answer: 'I do not have housing (staying with others, in a hotel, in a shelter, living outside on the street, on a beach, in a car or in a park)',
    },
];
export const livingSituationResidentialAndTreatmentList = [{ Answer: 'Temporary Housing' }, { Answer: 'Residential Care' }];
export const livingSituationOtherList = [
    { Answer: "Friend's Home" },
    { Answer: "Relative/Guardian's Home" },
    { Answer: 'Foster Care Home' },
    { Answer: 'Homeless, Living with a Friend' },
    { Answer: 'Homeless, Living in a Shelter' },
    { Answer: 'Homeless, No Residence' },
];
export const livingSituationTypesList = [{ Answer: 'Stable' }, { Answer: 'Multiple Moves' }];

export const levelOfSchoolList = [{ Answer: 'Less than high school degree' }, { Answer: 'Highschool diploma or GED' }, { Answer: 'More than high school' }];
export const modeOfTransportationList = [
    { Answer: 'Own vehicle' },
    { Answer: 'Friend/family member' },
    { Answer: 'Public transportation' },
    { Answer: 'None' },
];
export const workingSituationList = [
    { Answer: 'Unemployed' },
    { Answer: 'Part-time or temporary work' },
    { Answer: 'Full-time work' },
    {
        Answer: 'Otherwise unemployed but not seeking work (student, retired, disabled, unpaid primary care giver) Please write',
    },
];
export const totalIncomeList = [
    { Answer: 'I have no income' },
    { Answer: 'Less than poverty threshold' },
    { Answer: 'Less than $35,000' },
    { Answer: '$35,001 to $50,000' },
    { Answer: '$50,001 to $75,000' },
    { Answer: '$75,001 to $100,000' },
];
export const yesNoList = [{ Answer: 'Yes' }, { Answer: 'No' }];
export const frequencyOfTalkingPeopleList = [
    { Answer: 'Less than once a week' },
    { Answer: '1 or 2 times a week' },
    { Answer: '3 to 5 times a week' },
    { Answer: '5 or more times a week' },
];
export const stressLevelList = [
    { Answer: 'Not at all' },
    { Answer: 'A little bit' },
    { Answer: 'Somewhat' },
    { Answer: 'Quite a bit' },
    { Answer: 'Very much' },
];
export const emotionallySafeList = [{ Answer: 'Yes' }, { Answer: 'No' }, { Answer: 'Unsure' }];
export const afraidOfPartnerList = [{ Answer: 'Yes' }, { Answer: 'No' }, { Answer: 'Unsure' }, { Answer: 'I have not had a partner in the past year' }];

export const sexualOrientationList = [
    { Answer: 'Bisexual' },
    { Answer: 'Gay' },
    { Answer: 'Heterosexual or straight' },
    { Answer: 'Lesbian' },
    { Answer: 'Self-Identified' },
];

export const contextualNonPersonalFactorsList = [
    { Answer: 'Not Applicable' },
    { Answer: 'Divorce in the family' },
    { Answer: 'A recent death' },
    { Answer: 'Natural disaster' },
    { Answer: 'Economic downturn' },
    { Answer: 'Other' },
];

// Poverty guidelines
export const povertyGuidelines = [
    { NoOfPersons: 1, Amount: 12760 },
    { NoOfPersons: 2, Amount: 17240 },
    { NoOfPersons: 3, Amount: 21720 },
    { NoOfPersons: 4, Amount: 26200 },
    { NoOfPersons: 5, Amount: 30680 },
    { NoOfPersons: 6, Amount: 35160 },
    { NoOfPersons: 7, Amount: 39640 },
    { NoOfPersons: 8, Amount: 44120 },
    { NoOfPersons: 9, Amount: 48600 },
    { NoOfPersons: 10, Amount: 53080 },
];

export const medicationReviewList = [
    { Id: 1, Name: 'Yes, with no changes or no meds' },
    { Id: 2, Name: 'yes, new medications' },
    { Id: 3, Name: 'yes, changes in previous medications' },
    { Id: 4, Name: 'Unable to review' },
    { Id: 5, Name: 'Not available' },
];

export const dischargeOrderReviewList = [
    { Id: 1, Name: 'Yes, understands' },
    { Id: 2, Name: 'yes, not understanding education and follow up required' },
    { Id: 3, Name: 'Not available' },
];

export const appointmentScheduleList = [
    { Id: 1, Name: 'Yes, scheduled' },
    { Id: 2, Name: 'No, needs to be scheduled' },
];

export const medicalEquipmentList = [
    { Id: 1, Name: 'Yes, received' },
    { Id: 2, Name: 'yes, not started or received' },
    { Id: 3, Name: 'Not available' },
    { Id: 4, Name: 'Not applicable' },
];

export const legalJusticeInvolvementList = [
    { Answer: 'None' },
    { Answer: 'Past' },
    { Answer: 'Present' },
    // {Answer: 'Both'},
];

export const SUCCESS = 'success';
export const ERROR = 'error';
export const WARNING = 'warning';

export const TransitionalCare = 'Transitional Care';

export const states = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];

export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const getParentUrl = () => {
    return window.location.origin + '/';
};

export const parentUrl = getParentUrl();

export const smallModalStyle = {
    position: 'absolute' as 'absolute',
    top: '400px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '1px solid #808080',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
};

export const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '400px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '1px solid #808080',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
};

export const largeModalStyle = {
    position: 'absolute' as 'absolute',
    top: '400px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1200,
    bgcolor: 'background.paper',
    border: '1px solid #808080',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
};

export const licensures = [
    { Name: 'LPC', Id: '56ba0148b6a2d91c0c972871' },
    { Name: 'LASAC', Id: '56ba0148b6a2d91c0c972874' },
    { Name: 'LCSW', Id: '56ba0148b6a2d91c0c972875' },
    { Name: 'LMSW', Id: '56ba0148b6a2d91c0c972876' },
    { Name: 'BHT', Id: '56ba0148b6a2d91c0c972877' },
    { Name: 'LISAC', Id: '56ba0148b6a2d91c0c972873' },
    { Name: 'LAC', Id: '56ba0148b6a2d91c0c972872' },
    { Name: 'Psychiatrist', Id: '56ba0148b6a2d91c0c972878' },
    { Name: 'Psychologist', Id: '56ba0148b6a2d91c0c972879' },
    { Name: 'NP', Id: '56ba0148b6a2d91c0c972880' },
];

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

export const healthPlanPriorities = [{ value: 'Primary' }, { value: 'Secondary' }, { value: 'Tertiary' }, { value: 'Other' }];

export const ROLE_NAMES = {
    NURSE_PRACTITIONER: 'Nurse Practitioner',
    BEHAVIOURAL_HEALTH_SPECIALIST: 'Behavioural Health Specialist',
} as const;

export const SDOH_REQUEST_HANDLER = 'Care Team Member';

export const YES = 'Yes';
export const NO = 'No';
